var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"client-home"},[_c('div',[_c('home-carousel'),_c('home-advantage'),_c('home-footer')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }